import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import TapSelect from '../../../components/ui/TapSelect';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';


const InitializedModel = ({ allMeters, data, reloadList }, ref) => {

    const linkingUrl                =   BACKOFFICE_BASE_URL + '/asset_matrix_scs_linking_add';
    const access_token              =   useSelector(state => state.auth.access_token);

    const modalElem                 =   useRef(null);
    const modal                     =   useRef(null);

    const initialData               =   {
        scs_ids                         :   data.scs_ids,
        asset_matrix_id                 :   data.asset_matrix_id,
        status                          :   2,
        days_interval                   :   0,
        days_check                      :   'N'
    }

    const [submitForm, setSubmitForm]   =   useState(false);
    const [formData, setFormData]       =   useState(initialData);

    useImperativeHandle(ref, () => ({
        initModalHandler: (data) => {
            if(data) {
                console.log(data);
                setFormData(data);
                modalOpen();
            }else {
                modalOpen();
            }
        }
        // resetForm: resetForm
    }));

    useEffect(() => {
        modalElem.current   =   document.getElementById("InitializedModel");
        modal.current       =   new Modal(modalElem.current, { keyboard: false, backdrop: false });

        let formDataKeys    =   formData;
        allMeters.length > 0 && allMeters.forEach(am => {
            formDataKeys    =   {...formDataKeys, [am.key] : 'N', ['interval_' + am.key] : 0}
        })
        setFormData({...formDataKeys, scs_ids : data.scs_ids, asset_matrix_id : data.asset_matrix_id})
    }, [data]);
  
    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose        =   ()  =>  {
        setFormData(initialData);
        if (modal.current) { modal.current.hide(); }
    };

    const submitFormData    =   (e)  =>  {
        e.preventDefault();

        setSubmitForm(true);
        
        HttpAPICall.withAthorization('put', linkingUrl, access_token, {}, formData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            reloadList();
            modalClose();
        })
        .then(() => setSubmitForm(false));
    }

    const handleInputData   =   (e, key = null)  =>  {  
        if(key) {
            if(e.target.value) {
                setFormData(pre => ({...pre, [e.target.name] : e.target.value, [key] : 'Y'}));
            }else {
                setFormData(pre => ({...pre, [e.target.name] : e.target.value, [key] : 'N'}));
            }
        }else {
            setFormData(pre => ({...pre, [e.target.name] : e.target.value}))
        }      
    }
    

    const initializedModelJsx = () => {
        return (
            <div className="modal fade" id="InitializedModel" tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Change Interval</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => modalClose()}></button>
                        </div>
                        <form id="modelSearchForm" onSubmit={submitFormData}>
                            <div className="modal-body">
                                {
                                <>
                                    <div className="row my-3 align-items-center">
                                        <div className="col-sm-3">
                                            <label htmlFor="site_id" className="form-label">Tracking status</label>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    name="status"
                                                    type="radio"
                                                    value={1}
                                                    onChange={(e) => handleInputData(e)}
                                                    checked={formData.status == 1}
                                                    className="form-check-input"
                                                    required={true}
                                                    id="trackingStatusFormEnable"
                                                />
                                                <label className="form-check-label" htmlFor="trackingStatusFormEnable">Enable</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    name="status"
                                                    type="radio"
                                                    value={2}
                                                    onChange={(e) => handleInputData(e)}
                                                    className="form-check-input"
                                                    required={true}
                                                    checked={formData.status == 2}
                                                    id="trackingStatusFormDisable"
                                                />
                                                <label className="form-check-label" htmlFor="trackingStatusFormDisable">Disable</label>
                                            </div>
                                        </div>
                                    </div>
                                    {meterData()}
                                    <div className="row my-3 align-items-center">
                                        <div className="col-sm-3">
                                            <label className="col-form-label">Days</label>
                                        </div>
                                        <div className="col-sm-5">
                                            <input
                                                name='days_interval'
                                                type="text"
                                                className="form-control"
                                                placeholder="Days Interval"
                                                onChange={(e) => handleInputData(e, 'days_check')}
                                                style={{ height: "30px", fontSize: "93%" }}
                                                autoComplete="off"
                                                value={formData.days_interval || ''}
                                            />
                                        </div>
                                    </div>
                                </>
                                }
                            </div>
                            <div className="modal-footer">
                                <button type="button" disabled={submitForm} className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => modalClose()}>Close</button>
                                <button type="submit" disabled={submitForm} className="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    const meterData =   ()  =>  {
        return allMeters.map(meter => (
            <div className="row my-3">
                <div className="col-sm-3">
                    <label className="col-form-label">{meter.name}</label>
                </div>
                <div className="col-sm-5">
                    <input
                        name={'interval_' + meter.key}
                        type="text"
                        className="form-control"
                        placeholder={meter.name}
                        onChange={(e) => {
                            handleInputData(e, meter.key);    
                        }}
                        value={formData?.['interval_' + meter.key]}
                        style={{ height: "30px", fontSize: "93%" }}
                        autoComplete="off"
                        // value={formData.days_interval || ''}
                    />
                </div>
            </div>
        ))
    }

    return (
        <>
            {initializedModelJsx()}
        </>
    );
};

export default forwardRef(InitializedModel);
